import {LogoutLink} from '/src/com/yext/platform/users/js/newloginhelpers/logoutbutton';
import NewLoginTemplate from '/src/com/yext/platform/users/js/newloginhelpers/newlogintemplate';
import {registerComponentForJsonDataWithUIKit} from '/ui/lib/easyuikit';
import {yext} from '/ui/lib/msg';

const {Box, Text, Link} = require('@yext/mana-ui');

/**
 * Component to render the access denied page
 */
export function AccessDenied({employeeId, businessId, hasAccountAccess, businessName, businessPrimaryUserId,
  queryString, destinationUrl, username, supportEmail, authenticityToken, whitelabelInfo}) {
  return (
    <NewLoginTemplate
      title={employeeId ? yext.msg('Login to this account?') : yext.msg('Access Denied')}
      cardContent={
        <CardContent
          employeeId={employeeId}
          businessId={businessId}
          hasAccountAccess={hasAccountAccess}
          businessName={businessName}
          businessPrimaryUserId={businessPrimaryUserId}
          queryString={queryString}
          destinationUrl={destinationUrl}
          username={username}
          supportEmail={supportEmail}
          authenticityToken={authenticityToken}
        />}
      whitelabelInfo={whitelabelInfo}
    />
  );
}

function CardContent({employeeId, businessId, hasAccountAccess, businessName, businessPrimaryUserId,
  queryString, destinationUrl, username, supportEmail, authenticityToken}) {
  if (employeeId) {
    let employeeLoginUrl = `/users/employeelogin?userId=${businessPrimaryUserId}`;
    if (queryString) {
      employeeLoginUrl += `&${queryString}` + window.location.hash;
    }
    const accountUrl = `/admin2/customers/${businessId}?destinationUrl=${destinationUrl}` + window.location.hash;
    const text = hasAccountAccess
      ? (<div id="access-denied">
        <Text fontSize={'sm'}>
          {yext.msg('You were logged into a different customer account or not logged in yet. You can access this link by switching to the new account.')}
        </Text>
        <br />
        <Link
          as={'a'}
          href={employeeLoginUrl}
          palette={'primary'}
          size={'lg'}
          flexShrink={0}
          id={'login-url'}
        >
          {yext.msg('Yes, login to {businessName}', {businessName})}
        </Link></div>)
      : (<div id="access-denied">
        <Text fontSize={'sm'}>
          {yext.msg('You were logged into a different customer account or not logged in yet. You can request account access from the overview page.')}
        </Text>
        <br />
        <Link
          as={'a'}
          href={accountUrl}
          palette={'primary'}
          size={'lg'}
          style={{whiteSpace: 'nowrap'}}
          flexShrink={0}
          id={'login-url'}
        >
          {yext.msg('Go to Account Overview to Request Access')}
        </Link></div>);
    return (
      <Box>
        {text}
        <br />
        <Text fontSize={'sm'}>
          {yext.msg('This page is shown because you are logged in to the Yext admin. If you went directly to this link and were not a Yext employee, you would receive an Access Denied message.')}
        </Text>
      </Box>
    );
  }

  const userText = username
    ? (<div id="access-denied">
      <Text fontSize={'sm'}>
        {yext.msg('Your user, {username}, does not have access to this account.', {username})}
      </Text></div>)
    : (<div id="access-denied">
      <Text fontSize={'sm'}>
        {yext.msg('Your user does not have access to this account.')}
      </Text></div>);
  return (
    <Box>
      {userText}
      <br />
      <Text fontSize={'sm'}>
        {yext.msg('If you have a different user that has access to this page, please ')}
        <LogoutLink authenticityToken={authenticityToken} />
        {yext.msg(' then log back in with that new account and try again.')}
      </Text>
      <br />
      <Text
        fontSize={'sm'}
        dangerouslySetInnerHTML={{__html: yext.msg('If you need additional assistance, please <a href="mailto:{supportEmail}" >contact support</a>.', {supportEmail})}} />
    </Box>);
}

document.addEventListener('DOMContentLoaded', () => {
  registerComponentForJsonDataWithUIKit('AccessDenied', AccessDenied);
});
